define('contestacao-vistoria-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
    var app = angular.module('contestacao.vistoria.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
    app.factory('ContestacaoVistoria', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
        function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
            return {
                getVistorias: function() {
                    return $q(function(resolve, reject) {
                        return $http.get(appRoute.linkTo('contestacaoVistoria.getVistorias')).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                },

                getContestacao: function(vistoriaId) {
                    return $q(function(resolve, reject) {
                        return $http.get(appRoute.linkTo('contestacaoVistoria.getContestacao',vistoriaId)).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                },

                reloadContestacao: function(vistoriaId) {
                    return $q(function(resolve, reject) {
                        return $http.get(appRoute.linkTo('contestacaoVistoria.reloadContestacao',vistoriaId)).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                },

                notifImobContest: function(vistoriaId) {
                    return $q(function(resolve, reject) {
                        return $http.get(appRoute.linkTo('contestacaoVistoria.notifImobContest',vistoriaId)).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                },

                saveContestacao: function(vistoriaId, data) {
                    return $q(function(resolve, reject) {
                        return $http.post(appRoute.linkTo('contestacaoVistoria.saveContestacao',vistoriaId),data).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                },

                deleteContestacao: function(vistoriaId, data) {
                    return $q(function(resolve, reject) {
                        return $http.post(appRoute.linkTo('contestacaoVistoria.deleteContestacao',vistoriaId),data).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                },
            }
        }
    ]);
});


